module.exports = __webpack_public_path__ + "static/media/clock.091cb865.svg";